export default "__VITE_ASSET__CBzYXlN1__"